import {
  CONTACT_US_LIST,
  SET_CANCEL_ACTION_RESPONSE,
  SET_CLOSE_ACTION_RESPONSE,
  SET_REJECT_ACTION_RESPONSE,
  SET_FORWARD_ACTION_RESPONSE,
  SET_VIEW_LEAD_RESPONSE,
  EMAIL_LOGS_LIST
} from "../actions/userAction/actionTypes";

const initialObject = {
  loading: false,
  message: "",
  isSuccess: false,
  isDuplicateUser: "null",
  contactList: [],
  leadStatus: [],
  EmailLogsList:[],
  singleLeadData: null,
};

export const adminUserReducer = (state = initialObject, action) => {
  switch (action.type) {
    case CONTACT_US_LIST:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        contactList: action.payload.data.data,
        totalCount: action.payload.data.totalCount,
        isSuccess: action.payload.success,
      };
      case EMAIL_LOGS_LIST:
        console.log("Reducer Payload (Full API Response):", action.payload);
        console.log("EmailLogsList Data:", action.payload.data?.data);
        return {
          ...state,
          loading: false,
          message: action.payload.message,
          EmailLogsList: action.payload.data?.data ,
          totalCount: action.payload.data?.totalCount , 
          isSuccess: action.payload.success,
        };
      
    case SET_CANCEL_ACTION_RESPONSE:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        loading: false,
        message: action.payload.data.message,
        leadStatus: action.payload.data.data?.leadStatus || {},
        isSuccess: action.payload.success,
      };
    case SET_CLOSE_ACTION_RESPONSE:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        loading: false,
        message: action.payload.data.message,
        leadStatus: action.payload.data.data?.leadStatus || {},
        isSuccess: action.payload.success,
      };
    case SET_REJECT_ACTION_RESPONSE:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        loading: false,
        message: action.payload.data.message,
        leadStatus: action.payload.data.data?.leadStatus || {},
        isSuccess: action.payload.success,
      };
    case SET_FORWARD_ACTION_RESPONSE:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        loading: false,
        message: action.payload.data.message,
        leadStatus: action.payload.data.data?.leadStatus || {},
        isSuccess: action.payload.success,
      };
      case SET_VIEW_LEAD_RESPONSE:
        console.log("Reducer Payload (Full API Response):", action);
        return {
          ...state,
          loading: false,
          message: action.payload.data.message,
          singleLeadData: action.payload.data,
          isSuccess: action.payload.success,
        };
    default:
      return state;
  }
};
